import React, { useState, useEffect } from "react"; // Added useState, useEffect
import PuffLoader from "react-spinners/PuffLoader";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import devtools from 'devtools-detect';
import { Checkbox, LinearProgress } from "@mui/material";
import md5 from 'md5'
import koterBackground from './koter.png';
import Box from "@mui/material/Box"; // **** IMPORT Box ****

import {
  // popupText, // Original popupText variable is unused in legacy, infoText array is used instead
  popupTitle,
  vertigisUrl,
  vertigisStagingUrl,
  kartportalBaseUrl,
  kartportalBaseDomain,
  publikum,
  useLocalhostApp,
  localhost,
  storageKey,
  storageValue,
  popupParameterName,
  popupTitleParameterName,
  devEnvs,
  blogs,
  advancedReleases
} from './constants'; // Assuming constants are compatible

import {
  cssOverride, // Assuming same style object name
  infoPanelStyle,
  headingStyle,
  timeStyle,
  contentStyle,
  linkStyle,
  checkboxContainerStyle,
  checkboxStyle,
  buttonStyle,
  fullScreenCenterStyle
} from './styles'; // Assuming same style object names

const infoPanelStyleWithBackground = {
  ...infoPanelStyle,
  backgroundImage: `url(${koterBackground})`,
};

// --- Constants specific to panel dismissal logic (like in Refactored) ---
const INFO_PANEL_DISMISSED_STATE_KEY = "infoPanelDismissedState_legacy"; // Use distinct key for safety

// Function to detect if the browser is 32-bit (keep as is)
function is32BitBrowser() {
  // ... (keep existing implementation)
    if(isMobile) return false
    const userAgent = navigator.userAgent;
    return userAgent.indexOf("WOW64") > -1 || userAgent.indexOf("Win64") === -1;
}

// --- Global variables setup (keep mostly as is, ensure correct initialization) ---
const time = Date.now()
let isDev = false
let isStaging = window.location.search.toLowerCase().includes("staging=true")
let context = publikum
let appId = window.REACT_APP_URL && window.REACT_APP_URL[context] ? window.REACT_APP_URL[context] : '';
let consoleIsOpen = devtools && devtools.isOpen;
let isMobile = false

// --- Helper functions (keep as is, ensure they are defined correctly) ---
function checkIfMobile(){
    // ... (keep existing implementation)
    // eslint-disable-next-line
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) isMobile = true;})(navigator.userAgent||navigator.vendor||(window).opera);
}
function contextExists(context) {
    if (!window.REACT_APP_URL) return false;
    return Object.keys(window.REACT_APP_URL).indexOf(context) > -1
}
function redirectToKartportalOrPublikum() {
    const kartportalId = window.REACT_APP_URL?.kartportal;
    if (kartportalId && !kartportalId.startsWith('<')) {
        window.location.replace(kartportalBaseUrl + kartportalId + kartportalBaseDomain);
    }
    context = publikum;
}
function getContext() {
    const splitHref = window.location.pathname.split('/')
    context = splitHref?.pop()?.toLowerCase()
    if (context === '') context = splitHref?.pop()?.toLowerCase()

    // Root and unknown paths go to the kartportal, or fall back to publikum if not configured
    if (!context || !contextExists(context) || context === 'kartportal') {
        redirectToKartportalOrPublikum();
        return;
    }

    if (context === useLocalhostApp) isDev = true;
    if (context === 'saksbehandler' && advancedReleases.includes(window.location.hostname.toLowerCase()))
        context = 'saksbehandlerstage';
}
function getSrc() {
    // ... (keep existing implementation)
    setAppidIfExists();
    if (isDev) return appId; // Should probably be 'localhost' based on AppRefactored? Verify 'localhost' constant. Assuming 'localhost' from constants.js
    if (isDev) return localhost;

    const newSearchParams = appId + addPopup()
    return isStaging
      ? vertigisStagingUrl + newSearchParams
      : vertigisUrl + newSearchParams;
}
function addPopup() {
    // ... (keep existing implementation)
    let newSearchParams = window.location.search?.replace('?', '&')
    if (window.location.search.indexOf(popupParameterName) > -1) return newSearchParams
    newSearchParams += "&" + popupParameterName + "=" + popupTitle // Note: Refactored used infoTitle here, legacy uses popupTitle
    newSearchParams += "&" + popupTitleParameterName + "=" + popupTitle
    return newSearchParams
}
function setAppidIfExists() {
    // ... (keep existing implementation)
    const searchParams = new URLSearchParams(window.location.search)
    if ( devEnvs.includes(window.location.hostname.toLowerCase()) && window.location.search.includes("appId")) appId = searchParams.get("appId");
}
function pause(){
    // ... (keep existing implementation)
    if (document.hidden) consoleIsOpen = true
}
function removeStorageDummyValue(storage) {
    // ... (keep existing implementation)
    if(!storage) return;
    const sessionValue = storage.getItem(storageKey);
    if (!sessionValue) return;
    try { // Add try-catch like in refactored
        const valueJson = JSON.parse(sessionValue);
        if (valueJson && valueJson['/'] && Object.keys(valueJson['/']).length === 0 && Object.keys(valueJson).length === 1) {
             storage.removeItem(storageKey);
        }
    } catch(e) { console.error("Error parsing storage key for removal:", e); }
}
function isDevtoolsOpen(event) {
    // ... (keep existing implementation)
    if (event.detail.isOpen) consoleIsOpen = true;
}
// --- End Helper Functions ---


function App() {
  // --- Define infoText and hash here (as done in legacy) ---
  const infoText = [
    `Velkommen til Origo Innsyn! Her er noen lenker for å hjelpe deg komme i gang`,
    `Hvis du leter etter nærmere informasjon om hva du kan gjøre med Origo Innsyn er dette stedet å starte`,
    `Ved nye versjoner av Origo Innsyn legger vi ut en liste over hva som er gjort siden sist. Her finner du både ny funksjonalitet, endringer og feilrettinger samt annet vi mener er relevant`
  ];
  const popupHash = md5(infoText.join(' '));

  // --- Run initial setup functions (as done in legacy) ---
  getContext(); // Sets global context, isDev, appId (potentially)
  appId = window.REACT_APP_URL?.[context] ?? ''; // Ensure appId is set based on final context
  checkIfMobile();
  const src = getSrc(); // Calculate src based on final state

  // --- State Hooks ---
  const [dimensions, setDimensions] = useState({
    height: window.innerHeight,
    width: window.innerWidth,
  });
  const [loadTime, setLoadTime] = useState(null);
  const [loading, setLoading] = useState(true);
  const [is32Bit, setIs32Bit] = useState(false);
  const [origoVersion, setOrigoVersion] = useState(null);
  const [isVersionReceived, setIsVersionReceived] = useState(false); // NEW: Track if version message arrived
  const [initialCheckDone, setInitialCheckDone] = useState(false); // NEW: Track if localStorage check was performed
  const [seeInfoOnLoad, setSeeInfoOnLoad] = useState(false); // MODIFIED: Default to false, decision made in useEffect
  const [dismissChecked, setDismissChecked] = useState(false); // NEW: Track checkbox state separately for saving logic
  const [blogUrl, setBlogUrl] = useState(blogs["null"]);
  const [loadProgress, setLoadProgress] = useState(0);

  // --- Effect for Session Storage (similar to Refactored) ---
  useEffect(() => {
    try{
      if(context === publikum && window.sessionStorage) {
        window.sessionStorage.setItem(storageKey, JSON.stringify(storageValue));
      }
      else if(context !== publikum){
        removeStorageDummyValue(window.sessionStorage);
        removeStorageDummyValue(window.localStorage);
      }
     }
     catch(e){
         console.error("Session storage operation failed:", e);
     }
  }, [context]); // Depend only on context

  // --- Effect to Decide Info Panel Visibility (NEW) ---
  useEffect(() => {
    // Only run after version is received AND the check hasn't been done yet
    if (isVersionReceived && !initialCheckDone && origoVersion) {
        let showPanel = true;
        try {
            const dismissedStateRaw = localStorage.getItem(INFO_PANEL_DISMISSED_STATE_KEY);
            if (dismissedStateRaw) {
                const dismissedState = JSON.parse(dismissedStateRaw);
                // Check if the saved state matches the current version and text hash
                if (dismissedState.hash === popupHash && dismissedState.version === origoVersion) {
                    showPanel = false; // Don't show if hash and version match dismissed state
                } else {
                    // Clear old state if it doesn't match (optional, but good practice)
                    localStorage.removeItem(INFO_PANEL_DISMISSED_STATE_KEY);
                }
            }
        } catch (e) {
            console.error("Error reading or parsing localStorage for dismissed state:", e);
            showPanel = true; // Default to showing if error
        }

        if(showTime()) showPanel = true
        setSeeInfoOnLoad(showPanel); // Set the state that controls rendering
        setDismissChecked(false); // Reset checkbox visual state when panel logic runs
        setInitialCheckDone(true); // Mark check as done for this session/version
    }
  }, [isVersionReceived, initialCheckDone, origoVersion, popupHash]); // Dependencies

  // --- Main Effect for Listeners (Keep legacy structure, add version tracking) ---
  useEffect(() => {
    setIs32Bit(is32BitBrowser());

    const allowedOrigins = [
      localhost,
      "https://apps.geocortex.com", // Added trailing slash consistency, check if needed
      "https://apps.vertigisstudio.com",
      "https://apps-staging.vertigisstudio.com",
    ]; // Adjusted list slightly like refactored

    function handleResize() {
      setDimensions({
        height: window.innerHeight,
        width: window.innerWidth,
      });
    }

    function logTimeStuff(messsage, key) {
      // ... (keep existing implementation)
        const timeNumber = ((Date.now() - time) / 1000)
        const timeString = timeNumber.toString();
        const logString = "[Timing]: " + messsage + " in " + timeString + " seconds";
        console.log(logString);
        if(key !== "viewUpdated") return

        setLoadTime(timeNumber)

        if(consoleIsOpen) return;
        const oldStorageKey = appId + '_' + key
        const newStorageKey = oldStorageKey + '_2' // Assuming this naming is intentional
        const storedValues = JSON.parse(window.localStorage.getItem(newStorageKey)) ?? {'avg': 0, 'count': 0}
        const newTotal = (storedValues['avg'] * storedValues['count']) + timeNumber
        storedValues['count'] +=1
        storedValues['avg'] = newTotal / storedValues['count']
        window.localStorage.setItem(newStorageKey, JSON.stringify(storedValues))
        const data = {
          "navigator": { "userAgent": navigator.userAgent }, // Simplified navigator data
          "appId": appId,
          "isPublikum": (context === publikum),
          "seconds": timeNumber,
          "average": storedValues['avg'],
          "count": storedValues['count'],
          "hostname": window.location.hostname
        }
        const logUrl = "https://statistikk.kommunegis.no/innsyn/"
        fetch(logUrl, {
          method: "POST",
          body: JSON.stringify(data),
          headers: { "Content-Type": "application/json", },
          keepalive: true, // Added keepalive like refactored
        }).catch(error => console.warn("Stats logging fetch failed:", error));
    }

    const setLoadProgressState = (progress) => { // Keep internal helper
      if(progress === 50) setLoading(false)
        setLoadProgress((currentProgress) => {
          if (currentProgress >= progress) return currentProgress;
          // console.log(`loadprogress is ${currentProgress} setting new progress ${progress}`); // Keep or remove log
          return progress;
        });
      }

    function handleMessage(event) {
      // Simple origin check (adjust if stricter check from refactored is needed)
       if (!allowedOrigins.some(origin => event.origin === origin)) { // Use stricter check
           return;
       }

      // Determine message type/payload (simplified compared to refactored)
      let eventData = event.data;
      let messageType = Array.isArray(eventData) ? eventData[0] : eventData;
      let messagePayload = Array.isArray(eventData) && eventData.length > 1 ? eventData[1] : null;


      switch (messageType) {
        case "uiLoading":
          setLoadProgressState(20);
          setTimeout(() => setLoadProgressState(35), 4000);
          setTimeout(() => setLoadProgressState(50), 8000);
          setTimeout(() => setLoadProgressState(65), 10000);
          setTimeout(() => setLoadProgressState(75), 14000);
          break;
        case "uiLoaded":
          setLoadProgressState(80);
          logTimeStuff("UI Loaded", messageType); // Added logging like refactored
          break;
        case "mapLoaded":
          setLoadProgressState(90); // Changed from 50 to match refactored logic more closely
          logTimeStuff("Map initialized", messageType);
          setLoading(false);
          break;
        case "viewUpdated":
          setLoadProgressState(100);
          logTimeStuff("View updated", messageType);
          setLoading(false); // Ensure loading is false like refactored          
          break;
        case "version":
          if (messagePayload) { // Check payload exists
              const receivedVersion = String(messagePayload);
              setLoadProgressState(10);
              setOrigoVersion(receivedVersion);
              setIsVersionReceived(true); // **** SET FLAG ****

              const majorVersion = receivedVersion.split('.')[0];
              const versionSuffix = receivedVersion.replaceAll('.', ''); // Create suffix like refactored
              const baseBlogUrl = blogs[majorVersion] ?? blogs["null"];
              setBlogUrl(`${baseBlogUrl}#origo-innsyn-${versionSuffix}`); // Use suffix like refactored
          } else {
              console.warn("Received 'version' message without payload:", eventData);
          }
          break;
        case "alive":
            logTimeStuff("App reports alive status", messageType);
            const frame = document.getElementById('origo-frame');
            if (frame && frame.contentWindow) { // Check frame exists
                // Send string like legacy, ensure targetOrigin for security if possible
                 const targetOrigin = src.startsWith('http://localhost') ? localhost : new URL(src).origin;
                 // frame.contentWindow.postMessage(window.location.host); // Original legacy
                 frame.contentWindow.postMessage(window.location.host, targetOrigin); // Safer legacy postMessage
            }
            break;
        default:
          break;
      }
    }

    window.addEventListener("resize", handleResize);
    window.addEventListener("message", handleMessage, false);
    document.addEventListener("visibilitychange", pause);
    window.addEventListener('devtoolschange', isDevtoolsOpen);

    // Cleanup function
    return () => { // Use arrow function consistency
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("message", handleMessage);
      window.removeEventListener('devtoolschange', isDevtoolsOpen);
      document.removeEventListener("visibilitychange", pause);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [src, appId, context, popupHash]); // Adjusted dependencies slightly, popupHash needed for effect

  // --- Event Handlers ---

  const checkChange = (e) => {
    // MODIFIED: Only update the visual state of the checkbox
    setDismissChecked(e.target.checked);
  };

  const buttonClick = () => {
    // MODIFIED: Close panel and save state ONLY if checkbox is checked
    setSeeInfoOnLoad(false); // Close the panel visually

    if (dismissChecked && origoVersion) { // Checkbox state AND version must exist
        try {
            const stateToSave = { version: origoVersion, hash: popupHash };
            localStorage.setItem(INFO_PANEL_DISMISSED_STATE_KEY, JSON.stringify(stateToSave));
            // console.log("Saved dismiss state:", stateToSave);
        } catch (e) {
            console.error("Failed to save dismissed state to localStorage:", e);
        }
    } else {
        // If checkbox is not checked when closing, ensure any previous dismissed state is removed
        try {
             localStorage.removeItem(INFO_PANEL_DISMISSED_STATE_KEY);
             // console.log("Removed dismiss state.");
        } catch (e) {
            console.error("Failed to remove dismissed state from localStorage:", e);
        }
    }
  };

  // --- Helper to get Iframe JSX (keep as is) ---
  const getIframe = () => {
    return <iframe
      title="Origo"
      allow="geolocation 'src'; clipboard-read 'src'; clipboard-write 'src';"
      src={src}
      // frameBorder="0" // Deprecated, use CSS border: 0
      id="origo-frame"
      style={{
        overflow: "hidden",
        height: dimensions.height,
        width: dimensions.width,
        display: "block",
        position: "relative", // Keep or remove based on layout needs
        border: "0" // Replaces frameBorder
      }}
      // sandbox attribute removed
      />;
  };

  // Calculate documentation URL (keep logic)
  const documentationUrl = "https://dokumentasjon.kommunegis.no/docs/innsyn/innsyn_" + (context === 'publikum' ? "publikum/" : "saksbehandler/");

  const showTime = () => {
    const searchParams = new URLSearchParams(window.location.search)

    return (searchParams.has('showtime') && searchParams.get('showtime'))
  }

  // --- Render function for Info Panel (keep mostly as is) ---
  const seeInfoPanel = (currentLoadProgress) => {
    // This function now just returns the JSX, visibility is controlled by seeInfoOnLoad
    return (
      // Original legacy used <div style={cssOverride}> wrapping the panel, refactored used Modal+Fade+Box
      // Keep legacy structure for minimal change:
      <div style={cssOverride}>
        <div style={infoPanelStyleWithBackground}>
           {/* Title uses origoVersion like before */}
          <h2 style={headingStyle}>Origo Innsyn {origoVersion ? `v${origoVersion}` : 'Info'}</h2>
          {/* Progress bar uses state variable */}
          <LinearProgress variant="determinate" value={currentLoadProgress} style={{ marginBottom: '20px' }} />
          {(loadTime && showTime()) && <h3 style={timeStyle}>Side lastet på {loadTime} sekunder</h3>}
          <div style={contentStyle}>
            {is32Bit && <p><strong>OBS!</strong> Det virker som du bruker en 32-bit nettleser...</p>}
            <p>{infoText[0]}</p>
            <p>
              <a href={documentationUrl} target="_blank" rel="noreferrer" style={linkStyle}>Brukerveiledning</a>
            </p>
            <p>{infoText[1]}</p>
            <p>
              {/* Blog URL uses state variable */}
              <a href={blogUrl} target="_blank" rel="noreferrer" style={linkStyle}>Beskrivelse av siste endringer (Release Notes)</a>
            </p>
            <p>{infoText[2]}</p>
            <div style={checkboxContainerStyle}>
              <Checkbox
                 // MODIFIED: Checkbox controlled by dismissChecked state
                 checked={dismissChecked}
                 onChange={checkChange}
                 inputProps={{ 'aria-label': "Ikke vis igjen ved oppstart" }}
                 sx={checkboxStyle} // Use sx prop like refactored
              />
               {/* MODIFIED: Text consistency with refactored */}
              <span>Ikke vis igjen ved oppstart</span>
            </div>
            {/* Add small note like refactored */}
            <small style={{display: 'block', marginTop: '5px', color: '#555'}}> (Panelet vises likevel hvis versjon eller tekst oppdateres)</small>
          </div>
          {/* Button uses state variable */}
          <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%' }}>
            <button onClick={buttonClick} style={buttonStyle}>Lukk</button>
          </div>
        </div>
      </div>
    );
  }

  // --- Main Render Logic ---

  // MODIFIED: Simplified render logic. Always render iframe. Overlay modals.
  return (
    <div>
        {/* Loader Modal: Shows only when loading AND info panel isn't showing */}
        <Modal
            open={loading && !seeInfoOnLoad} // Show loader only when loading AND panel is hidden
            closeAfterTransition
            style={{
                pointerEvents: "none", // Non-interactive
                zIndex: 1300 // Ensure loader is above iframe
            }}
            >
            {/* Use Fade like refactored */}
             <Fade in={loading && !seeInfoOnLoad} timeout={3000}>
              <Box sx={fullScreenCenterStyle}>
                <PuffLoader
                    color="#36d7b7"
                    size={240}
                    speedMultiplier={0.38}
                  />
                </Box>
            </Fade>
        </Modal>

        {/* Info Panel Modal: Shows only when seeInfoOnLoad is true */}
        <Modal
            open={seeInfoOnLoad}
            // Close modal on backdrop click, trigger buttonClick logic (which handles saving state)
            onClose={(_, reason) => { if (reason === 'backdropClick') buttonClick(); }}
            closeAfterTransition
            aria-labelledby="info-panel-title"
            aria-describedby="info-panel-description"
            style={{ zIndex: 1400 }} // Ensure info panel is above loader and iframe
        >
            {/* Use Fade like refactored */}
            {/* We need to wrap the panel content in Fade */}
            <Fade in={seeInfoOnLoad} timeout={500}>
                 {/* Call the function that returns the panel JSX */}
                 {/* Pass loadProgress state to the panel rendering function */}
                 {seeInfoPanel(loadProgress)}
            </Fade>
        </Modal>

        {/* Iframe: Always rendered if src is available */}
        {src ? getIframe() : (
             <div style={{ padding: '20px', textAlign: 'center', color: 'red', height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                 Error: Application configuration is missing...
             </div>
        )}
    </div>
  );

} // End App Component

export default App;